import { GOOG_PAL_UPDATED } from '../actions/types';

const defaultState = false;

export const applicationUpdateGoogPalNonceReducer = (previousState = defaultState, action) => {
  let googPalNonce = previousState;
  if (action.type === GOOG_PAL_UPDATED) {
    googPalNonce = action.payload;
  }
  return googPalNonce;
};
